import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useGlobal } from '../contexts/global';
import { signInSSO, votacao } from '../services/Votacao';
import { getErrorMessage } from '../utils/errorHandler';

const LoginFacebook = () => {
  const location = useLocation();
  const history = useHistory();
  const { setSuccess, setError } = useGlobal();

  const vote = (token) => {
    const grecaptcha = window.grecaptcha?.enterprise || window.grecaptcha;
    grecaptcha.ready(() => {
      grecaptcha
        .execute(process.env.REACT_APP_KEY_RECAPTCHA, {
          action: 'submit'
        })
        .then(async (gtoken) => {
          try {
            if (localStorage.getItem('vote_data')) {
              const data = JSON.parse(localStorage.getItem('vote_data'));
              data.token_grecaptcha = gtoken;
              await votacao(data, token);
              setSuccess(true);
              const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
              history.push(savedCityPage || '/');
            }
          } catch (error) {
            const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
            const errorMessage = getErrorMessage(
              error,
              error.response?.status === 422
                ? 'Usuário já votou nessa categoria!'
                : 'Ops! Houve um erro, tente novamente mais tarde.'
            );
            setError(errorMessage);
            history.push(savedCityPage || '/');
          }
        });
    });
  };

  const login = async () => {
    try {
      const resp = await signInSSO(location.search, 'facebook');
      vote(resp.access_token);
    } catch (error) {
      const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
      const errorMessage = getErrorMessage(
        error,
        'Erro ao autenticar com Facebook. Tente novamente.'
      );
      setError(errorMessage);
      history.push(savedCityPage || '/');
    }
  };

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`,
      () => {}
    );
    login();
  }, []);

  return <></>;
};

export default LoginFacebook;
